import { Dashboard } from "./components/Dashboard";

export function Shipper() {
  return <Dashboard />;
}
